import { roles } from '@nxsys/store/constants';
import EmployeeListing from '../../../modules/employees/listing/EmployeeListing';
import EmployeesListing from '../../../modules/employees/listing/EmployeesListing';
import EmployeeDetail from '../../../modules/employees/detail';

export const employeesConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/employees',
    element: <EmployeesListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/employees-subcontractors',
    element: <EmployeeListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/employees-subcontractors/:employeeId',
    element: <EmployeeDetail />,
  },
];
